import { CommonModule } from '@angular/common';
import { ChangeDetectorRef, Component, input, InputSignal, OnDestroy, OnInit } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import {
  PartCategory,
  PartModel,
} from '../../../../workspace-layout/commons/services/project-controller/project-controller';
import { ThreeGraphqlService } from 'src/app/core/graphql/three/services/three-graphql.service';
import { environment } from 'src/environments/environment';
import { Subject, take } from 'rxjs';
import { CanvasControllerService } from '../../../../../../services/canvas-controller/canvas-controller.service';
import { PartListControllerService } from '../../../../workspace-layout/commons/services/part-list-controller/part-list-controller.service';
import { EmbedService } from '../../services/embed.service';

@Component({
  selector: 'embed-part-control',
  imports: [CommonModule, MatButtonModule, MatIconModule],
  templateUrl: './embed-part-control.component.html',
  styleUrl: './embed-part-control.component.scss',
})
export class EmbedPartControlComponent implements OnInit, OnDestroy {
  public partModelList: InputSignal<Array<PartModel>> = input(new Array<PartModel>());

  public isLoading: boolean = false;
  public isViewCompany: boolean = true;

  public categoryMap: Map<string, PartCategory> = new Map();

  public environment = environment;

  private unsubscribeAll: Subject<any> = new Subject();

  constructor(
    private embedSerivce: EmbedService,
    public threeGraphqlService: ThreeGraphqlService,
    private canvasController: CanvasControllerService,
    private partListController: PartListControllerService,
    private cd: ChangeDetectorRef,
  ) {}

  //--------------------------------------------------------------------------------------------------------
  // @ Life Circle
  //--------------------------------------------------------------------------------------------------------

  ngOnInit(): void {}

  ngOnDestroy(): void {}

  //--------------------------------------------------------------------------------------------------------
  // @ Public Method
  //--------------------------------------------------------------------------------------------------------

  public onClickSoundBtn(model: PartModel): void {
    const sound = model.sound;
    if (!sound) return;
    sound.stop();
    sound.play();
  }

  public onClickPart(part: PartModel): void {
    this.isLoading = true;

    if (!part.threedFile) {
      this.threeGraphqlService
        .getPartModel(part.uuid)
        .pipe(take(1))
        .subscribe((partModel: PartModel | undefined) => {
          if (!partModel) return;
          part = partModel;

          const beforePart = this.partListController.categoryMap.get(part.category || part.uuid);
          if (beforePart?.uuid == part?.uuid) {
            this.canvasController.removeModel(part);
            this.partListController.removePart(part);
            this.canvasController.stateManager.removeModel(part);

            part.isSelected = false;
            this.embedSerivce.selectedPart(part, false);
            this.isLoading = false;

            this.cd.markForCheck();
            return;
          }

          if (beforePart) {
            beforePart.isSelected = false;
            this.canvasController.removeModel(beforePart);
            this.partListController.removePart(beforePart);
          }
          this.canvasController.addModel(part).then(() => {
            part.isSelected = true;
            this.embedSerivce.selectedPart(part, true);
            this.canvasController.stateManager.addModel(part);
            this.partListController.addPart(part);
            this.isLoading = false;
            if (part.position && part.target) {
              this.canvasController.lookAt(JSON.parse(part.target), JSON.parse(part.position));
            }
            this.cd.markForCheck();
          });
        });
    } else {
      const beforePart = this.partListController.categoryMap.get(part.category || part.uuid);
      if (beforePart?.uuid == part?.uuid) {
        this.canvasController.removeModel(part);
        this.partListController.removePart(part);
        this.canvasController.stateManager.removeModel(part);

        part.isSelected = false;
        this.embedSerivce.selectedPart(part, false);
        this.isLoading = false;

        this.cd.markForCheck();
        return;
      }

      if (beforePart) {
        beforePart.isSelected = false;
        this.canvasController.removeModel(beforePart);
        this.partListController.removePart(beforePart);
      }
      this.canvasController.addModel(part).then(() => {
        part.isSelected = true;
        this.embedSerivce.selectedPart(part, true);
        this.canvasController.stateManager.addModel(part);
        this.partListController.addPart(part);
        this.isLoading = false;
        if (part.position && part.target) {
          this.canvasController.lookAt(part.position, part.target);
        }
        this.cd.markForCheck();
      });
    }
  }

  //--------------------------------------------------------------------------------------------------------
  // @ Private Method
  //--------------------------------------------------------------------------------------------------------
}
